export const AUTH_REQUEST="AUTH_REQUEST";
export const AUTH_SUCCESSFUL="AUTH_SUCCESSFUL";
export const AUTH_FAILURE="AUTH_FAILURE";

